module.exports = __webpack_public_path__ + "static/media/04-cht.d03ff671.png";